@if (appservice.isLoading || isSpinnerVisible) {
  <div
    class="toolbar-progress"
    >
    <mat-spinner [diameter]="64"></mat-spinner>
  </div>
}
